import React from 'react';
import { loadable } from '@shared/core/loadableFromNamedExport';
import { JoyLogoLoader } from '@shared/components/JoyLogoLoader';

// Same loader as the component's own checking state, so a slow chunk shows no blank gap.
export const LazyRoomBlockEmailRedirect = loadable(() => import(/* webpackChunkName: "content/roomBlockEmailRedirect" */ './RoomBlockEmailRedirect'), 'RoomBlockEmailRedirect', {
  fallback: <JoyLogoLoader loaderKey="room-block-email-redirect" />,
});
